// extracted by mini-css-extract-plugin
export default {"descriptionTextContainer":"JobsLink_descriptionTextContainer__StZQX","descriptionText":"JobsLink_descriptionText__aghDU","descriptionn":"JobsLink_descriptionn__ns6rJ"};